<template>
  <v-card elevation="1" class="mb-4">
    <v-card-text>
      <h6 class="text-h6 black--text">Forma de pago</h6>
      <p class="text-body-2">Seleccione la forma de pago y cuenta de tesoreria para la orden de pago</p>
      <v-row class="mt-0">
        <div class="col-md-4">
          <v-combobox
            v-model="item.payment_method"
            :items="paymentMethods"
            item-text="name"
            item-value="id"
            label="Forma de pago"
            autocomplete="off"
            clearable
            :disabled="isViewModal"
            @change="item.money_account = null"
          ></v-combobox>
        </div>
        <div class="col-md-4">
          <v-combobox
            v-model="item.money_account"
            :items="moneyAccounts"
            item-text="name"
            item-value="id"
            label="Cuenta"
            autocomplete="off"
            clearable
            :disabled="isViewModal || item.payment_method == null"
          ></v-combobox>
        </div>
        <div class="col-md-4">
          <v-autocomplete
            v-model="item.supplier_bank"
            :items="supplier_banks"
            :item-text="item => item.description + ' - ' + item.cbu_alias"
            item-value="id"
            return-object
            label="CBU/alias del proveedor"
            autocomplete="off"
            clearable
            :disabled="isViewModal || item.supplier == null"
          ></v-autocomplete>
        </div>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { generalService } from "@/libs/ws/generalService";
import sections from "@/constants/sections";
import paymentMethod from "@/constants/paymentMethod";
import { suppliersService } from "../../../libs/ws/suppliersService";

export default {
  created() {
    this.$validator = this.validator;
  },
  props: {
    item: Object,
    validator: Object,
    isViewModal: { type: Boolean, default: false },
    open: Boolean,
    receiver: { type: Object, default: null },
  },
  data: () => ({
    paymentMethods: [],
    moneyAccounts: [],
    supplier_banks: [],
  }),
  watch: {
    open: function (newValue) {
      if (newValue) {
        this.loadPaymentMethods();
        this.loadMoneyAccounts();
      }
    },
    'item.supplier': function () {
      this.loadSupplierBanks();
    },
    receiver: function () {
      this.item.money_account = null;
      this.loadMoneyAccounts();
    },
  },
  mounted() {
    this.loadPaymentMethods();
    this.loadMoneyAccounts();
    this.loadSupplierBanks();
  },
  methods: {
    loadSupplierBanks() {
      if (this.item.supplier) {
        const supplierId = this.item.supplier.id;
        suppliersService
          .list_supplier_bank({ supplier_id: supplierId })
          .then((response) => {
            if (!this.item.supplier || this.item.supplier.id !== supplierId) return;
            this.supplier_banks = response.result || [];
            if (!this.item.supplier_bank) {
              this.item.supplier_bank = response.result.find(bank => bank.is_default) || null;
            }
          })
          .catch((e) => {
            console.log("supplier_banks.filter error", e);
          });
      } else {
        this.supplier_banks = [];
      }
    },
    loadPaymentMethods() {
      generalService.setSection(sections.SECTION_PAYMENT_METHODS);
      generalService
        .filter()
        .then((response) => {
          const items = response.result || [];
          this.paymentMethods = items.filter((item) => item.id !== paymentMethod.cheque);
        })
        .catch((e) => {
          console.log("payment_methods.filter error", e);
        });
    },
    loadMoneyAccounts() {
      generalService.setSection(sections.SECTION_MONEY_ACCOUNTS);
      var param = {};
      if (this.receiver && this.receiver.id > 0) {
        param.emitter = { id: this.receiver.id };
      }
      generalService
        .filter(param)
        .then((response) => {
          this.moneyAccounts = response.result || [];
        })
        .catch((e) => {
          console.log("money_accounts.filter error", e);
        });
    },
  },
};
</script>
